export const MARK_IN = '1';
export const MARK_OUT = '2';
export const PAUSE_PLAY = 'space';
export const ONE_FRAME_BACK = 'left';
export const ONE_FRAME_FORWARD = 'right';
export const ONE_SECOND_BACK = 'shift+left';
export const ONE_SECOND_FORWARD = 'shift+right';
export const ALT_MARK_IN = 'i';
export const ALT_MARK_OUT = 'o';
export const REWIND_FIVE_SECONDS = 'j';
export const FAST_FORWARD_FIVE_SECONDS = 'l';
export const ALT_PAUSE_PLAY = 'k';
export const EXTEND_OUT = 'KeyO';
